export default __webpack_public_path__ + "static/media/material-mail.ef6c4cc0.svg";